import React, { useContext } from 'react';

import { Select, MenuItem, Grid, Skeleton, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import TroubleshootingErrorRow from './TroubleshootingErrorRow';
import { TroubleshootingDetailErrorLogsContext } from '../TroubleshootingDetailErrorLogsContext';

const StyledTable = styled(Table)`
    margin-bottom: 2rem;
`;

const Spacer = styled.div`
    margin: 1rem;
`;

const PaddedSkeleton = styled(Skeleton)`
    margin: 0.5rem 0;
`;

export const TroubleshootingDetailErrorLogs = () => {
    const { t } = useTranslation('portal');
    console.log('InsightsDetailErrors');
    const { insightsDetailErrors, isLoading, timeSpan, updateTimeSpan } = useContext(
        TroubleshootingDetailErrorLogsContext
    );

    const handleTimeSpan = (val: string) => {
        updateTimeSpan(val);
    };
    const handleTimeSpanChange = (event) => {
        window.localStorage.setItem('sortMode', event.target.value);
        handleTimeSpan(event.target.value);
    };

    if (isLoading) {
        return (
            <>
                <Grid container justifyContent="space-between">
                    <Grid item>
                        <Skeleton width={300} height={60} />
                    </Grid>
                    <Grid item>
                        <Skeleton width={150} height={60} />
                    </Grid>
                </Grid>
                <Spacer />
                <PaddedSkeleton height={35} />
                <PaddedSkeleton height={35} />
                <PaddedSkeleton height={35} />
                <PaddedSkeleton height={35} />
                <PaddedSkeleton height={35} />
                <Spacer />
                <Grid container justifyContent="flex-end">
                    <Skeleton width={400} height={50} />
                </Grid>
            </>
        );
    }

    return (
        <>
            <Table style={{ width: '100%', padding: '0px', margin: '0px' }}>
                <TableBody style={{ width: '100%', padding: '0px', margin: '0px' }}>
                    <TableRow style={{ width: '100%', padding: '0px', margin: '0px' }}>
                        <TableCell>
                            <Select
                                name="timeSpan"
                                onChange={handleTimeSpanChange}
                                value={timeSpan}
                                style={{ height: '42px' }}
                            >
                                <MenuItem value="day">{t('day')}</MenuItem>
                                <MenuItem value="week">{t('week')}</MenuItem>
                                <MenuItem value="month">{t('month')}</MenuItem>
                            </Select>
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
            <Spacer />
            <h2>{t(`errors-for-the-last-${timeSpan}`)}</h2>
            <StyledTable>
                <TableHead>
                    <TableRow>
                        <TableCell>{t('platform')}</TableCell>
                        <TableCell>{t('count')}</TableCell>
                        <TableCell>{t('title')}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {insightsDetailErrors.map((troubleshootingError, index) => (
                        <TroubleshootingErrorRow error={troubleshootingError} key={index}></TroubleshootingErrorRow>
                    ))}
                </TableBody>
            </StyledTable>
        </>
    );
};
